import { StatusWrapper } from '@/components/StatusWrapper/StatusWrapper';
import {
  API_KEY_STATUS_TEXT_DB,
  STATUS_API_KEY_MAP,
} from '@/bundle/_MasterAdmin/_DevelopersPage/ui/ApiKeyStatus/const';
import { ApiKeyStatusType } from '@/const/shared';

type ApiKeyStatusPropsType = {
  status: ApiKeyStatusType;
};

export const ApiKeyStatus = ({ status }: ApiKeyStatusPropsType) => {
  const statusText = API_KEY_STATUS_TEXT_DB[status] || '-';
  const statusVariant = STATUS_API_KEY_MAP[status]?.variant;

  return <StatusWrapper variant={statusVariant}>{statusText}</StatusWrapper>;
};
